import type { ReactNode } from 'react';

/** A full-page card for "not found" and "no access" states. */
export function CenteredMessage({
  icon,
  title,
  children,
}: {
  icon: ReactNode;
  title: string;
  children: ReactNode;
}) {
  return (
    <div className="dotted-backdrop flex min-h-full items-center justify-center px-4">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-float dark:border-slate-800 dark:bg-slate-900">
        <div className="mx-auto mb-4 grid size-12 place-items-center rounded-full bg-slate-100 text-slate-500 dark:bg-slate-800">
          {icon}
        </div>
        <h1 className="text-xl font-semibold">{title}</h1>
        <div className="mt-2 text-sm text-slate-500 dark:text-slate-400">{children}</div>
      </div>
    </div>
  );
}
